import Marquee from 'react-fast-marquee';
import { brands, brandsReversed } from './brandList.copy';
import { LogoPropsType } from '../Logos/logoTypes';

type MarqueeProps = React.ComponentProps<typeof Marquee>;
interface LogoMarqueeProps extends MarqueeProps {
  direction: 'left' | 'right';
  logos: React.ElementType[];
}

export function LogoMarquee({ direction, logos, ...rest }: LogoMarqueeProps) {
  return (
    <Marquee direction={direction} {...rest}>
      <ul className="mb-8 mr-20 flex items-center gap-20">
        {logos.map((Logo, index: number) => (
          <li key={`logo-${index}`} className="flex h-16 items-center object-contain">
            <Logo monochrome className="h-10 w-40 text-gray-3" />
          </li>
        ))}
      </ul>
    </Marquee>
  );
}

type BlurColors = '#0b0d0e' | 'white' | '#000000';

type LogosMarqueeProps = {
  blurToColor: BlurColors;
  customBrandList?: (({ monochrome, className }: LogoPropsType) => React.ReactElement)[];
};

export function LogosMarquee({ blurToColor, customBrandList }: LogosMarqueeProps) {
  const blurToColorMap: Record<BlurColors, string> = {
    '#000000': 'to-[#000000]',
    '#0b0d0e': 'to-[#0b0d0e]',
    white: 'to-white',
  };

  return (
    <div className="max-w-section relative w-full overflow-hidden">
      {/* Gradient */}
      <div
        className={`w-full from-transparent ${blurToColorMap[blurToColor]}  before:absolute before:bottom-0 before:right-0 before:top-0 before:z-10 before:w-12 before:bg-gradient-to-r before:content-[''] after:absolute after:inset-0 after:z-10 after:w-12 after:bg-gradient-to-l after:content-['']`}
      >
        <div className="flex flex-col gap-8">
          {customBrandList ? (
            <>
              <div className="h-16">
                <LogoMarquee direction="left" logos={customBrandList.slice(0, customBrandList.length / 2)} autoFill />
              </div>
              <div className="h-16">
                <LogoMarquee
                  direction="right"
                  logos={customBrandList.slice(customBrandList.length / 2, customBrandList.length - 1)}
                  autoFill
                />
              </div>
            </>
          ) : (
            <>
              <div className="h-16">
                <LogoMarquee direction="left" logos={brands} autoFill />
              </div>
              <div className="h-16">
                <LogoMarquee direction="right" logos={brandsReversed} autoFill />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default LogosMarquee;
